import { render, staticRenderFns } from "./ControlTable.vue?vue&type=template&id=402fa4b1&scoped=true&"
import script from "./ControlTable.vue?vue&type=script&lang=ts&"
export * from "./ControlTable.vue?vue&type=script&lang=ts&"
import style0 from "./ControlTable.vue?vue&type=style&index=0&id=402fa4b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402fa4b1",
  null
  
)

export default component.exports